import { round } from "lodash";
import "./style.scss";

const UserIcon = ({ color = "white" }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
  >
    <path
      d="M11.839 13.1503L11.839 11.8018C11.839 11.0865 11.5548 10.4005 11.049 9.89468C10.5432 9.38889 9.85723 9.10474 9.14193 9.10474L3.74783 9.10474C3.03253 9.10474 2.34652 9.38889 1.84073 9.89468C1.33493 10.4005 1.05078 11.0865 1.05078 11.8018L1.05078 13.1503"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.44314 6.40899C7.93268 6.40899 9.14019 5.20148 9.14019 3.71194C9.14019 2.2224 7.93268 1.01489 6.44314 1.01489C4.9536 1.01489 3.74609 2.2224 3.74609 3.71194C3.74609 5.20148 4.9536 6.40899 6.44314 6.40899Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BarChart = ({
  showLabel = true,
  bars,
  highlightBarIndex,
}: {
  showLabel?: boolean;
  bars: { value: number; label: string }[];
  highlightBarIndex?: number;
}) => {
  return (
    <div className={`bar-chart ${showLabel ? "" : "hide-label"}`}>
      <div className="bar-container">
        {bars.map((item, index) => (
          <div
            className={`bar-item ${
              highlightBarIndex === index ? "highlighted" : ""
            }`}
            key={index}
            style={{
              height: `${item.value}%`,
            }}
          >
            <div className="bar-cap">
              <span>{round(item.value, 1)}%</span>
              <UserIcon
                color={
                  highlightBarIndex === index
                    ? "var(--fl-color-primary)"
                    : "white"
                }
              />
            </div>
          </div>
        ))}
      </div>
      {showLabel && (
        <div className="bar-bottom">
          {bars.map((item, index) => (
            <div key={index} className="bar-bottom-wrap">
              <div
                className={`bar-bottom-label ${
                  highlightBarIndex === index ? "highlighted" : ""
                }`}
              >
                <span>{item.label || "\u00A0"}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
